import { useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import type { SearchHit } from './rank';
import { useGlobalSearch } from './use-global-search';

export function SearchBox() {
  const navigate = useNavigate();
  const search = useGlobalSearch();
  const [q, setQ] = useState('');
  const [dismissed, setDismissed] = useState(false);
  const wrap = useRef<HTMLDivElement>(null);
  const hits = useMemo(() => (dismissed ? [] : search(q)), [q, search, dismissed]);
  useEffect(() => {
    const onDoc = (e: MouseEvent) => { if (!wrap.current?.contains(e.target as Node)) setDismissed(true); };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);
  const go = (h: SearchHit) => { setQ(''); setDismissed(true); navigate(h.route); };
  return (
    <div ref={wrap} className="nav-search-wrap" style={{ position: 'relative' }}>
      <span className="nav-search-icon">🔍</span>
      <input
        type="text"
        className="nav-search"
        placeholder="Search incidents, problems, changes, KB, CIs, people…"
        autoComplete="off"
        value={q}
        onChange={(e) => { setQ(e.target.value); setDismissed(false); }}
        onFocus={() => setDismissed(false)}
        onKeyDown={(e) => {
          if (e.key === 'Escape') { setQ(''); setDismissed(true); }
          if (e.key === 'Enter' && hits[0]) go(hits[0]);
        }}
      />
      <div id="search-overlay" className={hits.length ? 'open' : ''} role="dialog" aria-label="Search results">
        <div className="search-overlay-header">{hits.length} result(s)</div>
        {hits.map((h) => (
          <button type="button" key={`${h.type}:${h.id}`} className="search-result-item" style={{ display: 'block', width: '100%', textAlign: 'left', background: 'none', border: 0, font: 'inherit', color: 'inherit' }} onClick={() => go(h)}>
            <span className="search-result-type">{h.type}</span>
            <div className="search-result-title">{h.id} — {h.title}</div>
            <div className="search-result-desc">{h.desc.slice(0, 90)}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
